import { Patient } from '../patient/patient';

export class Appointment {
  constructor(
    public id?: number,
    public date?: Date,
    public patient?: Patient,
    public main_complaint?: string,
    public current_desease_history?: string,
    public conduct?: string,
    public diagnostic_hypothesis?: string,
    public exams_results?: string,
    public family_history?: string,
    public personal_history?: string,
    public physical_exam?: string,
    public other?: string
  ) {}
}
